import React from 'react';

import { TestCycle } from '@qality/common-model';

export interface RecentTestCyclesContextProps {
  testCycles: TestCycle[];
  selectedTestCycle: TestCycle;
  isLoading: boolean;
  isTableView: boolean;
  isProjectContext: boolean;
  handleViewMore: () => void;
  handleOverviewAction: (testCycleId) => void;
}

const initialValues: RecentTestCyclesContextProps = {
  testCycles: [],
  selectedTestCycle: null,
  isLoading: true,
  isTableView: false,
  isProjectContext: false,
  handleViewMore: () => null,
  handleOverviewAction: (_testCycleId) => null,
};

export const RecentTestCyclesContext =
  React.createContext<RecentTestCyclesContextProps>(initialValues);
